import { TodoListComponent } from "./pages/todo-list/todo-list.component";
import { AuthGuard } from "../../auth/helpers";
import { AllTodoListComponent } from "./pages/all-todo-list/all-todo-list.component";
import { IRoute } from "app/auth/models/utils-interfaces";

const taskRoutes: IRoute[] = [
  {
    path: "dashboard/my-todo",
    component: TodoListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "dashboard/todo/all-list",
    component: AllTodoListComponent,
    canActivate: [AuthGuard],
  },
];

export default taskRoutes;
